import { useSelector } from 'react-redux'

import { paletteFor } from '../orbPalettes'

import { useAgentIdentifiers } from './useAgentIdentifiers'

// The palette for the agent open on the detail page, keyed exactly the way the
// list card keys it — so the blob you clicked is the blob in the header and in
// the call dock. That is the whole job of the orb: one agent, one colour,
// everywhere it appears.
//
// The key is the provisioning **slug**, not the PE agent id, and the two are
// routinely different: a config's agent_id is often a Cartesia-style handle
// (`agent_local_bt_claims_fnol`) while the slug is customer/agent
// (`balto-test/claims_fnol`). Hashing the wrong one hands the same agent two
// different colours, which is worse than having no orb at all — it reads as a
// different agent.
//
// The PE agent id is the fallback for the legacy `/:agentId` route, where no
// provisioning record resolves and there is no slug to hash. That page can't be
// reached from the card grid, so there is no card colour for it to contradict.
export const useAgentOrb = () => {
  const { slug } = useAgentIdentifiers()
  const selectedAgentId = useSelector((state) => state.voiceAgents.selectedAgentId)
  return paletteFor(slug || selectedAgentId)
}
